// Module
var code = " <gh-chart-legend *ngIf=\"drawn &amp;&amp; data.legendLayout\" class=\"m-legend\" [cells]=\"data.legendLayout\"></gh-chart-legend> <div class=\"m-body\"> <div id=\"chart\"></div> <gh-chart-axis *ngIf=\"data.axisLayout\" [labels]=\"data.axisLayout\"></gh-chart-axis> </div> ";
// Exports
module.exports = code;